import React from 'react';
import {Outlet, useNavigate} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import Card from '../ui/Card';
import Button from '../ui/Button';
import RouteLoadingFallback from '../RouteLoadingFallback';
import {usePlanAccess} from '../../hooks/usePlanAccess';
import {isIosConsumptionOnly} from '../../lib/billing/billingChannel';
import PlanAccessUnavailable from './PlanAccessUnavailable';

const {FiArrowRight, FiMapPin} = FiIcons;

export default function PlanFeatureRoute() {
  const navigate = useNavigate();
  const {isLoading, isError, isPlanResolved, isMileagePlan, refetch} = usePlanAccess();
  const iosConsumptionOnly = isIosConsumptionOnly();

  if (isLoading || (!isPlanResolved && !isError)) return <RouteLoadingFallback workspace />;
  if (isError || !isPlanResolved) return <PlanAccessUnavailable onRetry={refetch} />;
  if (!isMileagePlan) return <Outlet />;

  return (
    <div className="mx-auto max-w-2xl px-4 py-12 sm:px-6 lg:py-20">
      <Card interactive={false} className="p-7 text-center sm:p-10">
        <span className="mx-auto grid h-14 w-14 place-items-center rounded-2xl bg-mint text-primary">
          <SafeIcon icon={FiMapPin} className="h-6 w-6" />
        </span>
        <p className="mt-6 text-sm font-semibold text-primary">Mileage Plan</p>
        <h1 className="mt-2 text-2xl font-bold tracking-tight text-ink">
          Financial records are not included
        </h1>
        <p className="mx-auto mt-3 max-w-lg text-sm leading-6 text-gray-600">
          {iosConsumptionOnly
            ? 'Your Mileage Plan includes trips, vehicles, saved places, route templates and mileage exports. Financial record features are not available under your current plan.'
            : 'Your Mileage Plan includes trips, vehicles, saved places, route templates and mileage exports. Upgrade to Solo to create expenses, income, invoices, bank records or tax records.'}
        </p>
        <div className="mt-7 flex flex-col justify-center gap-3 sm:flex-row">
          {!iosConsumptionOnly && <Button onClick={() => navigate('/settings/billing')}>
            Compare plans
            <SafeIcon icon={FiArrowRight} className="h-4 w-4" />
          </Button>}
          <Button variant="secondary" onClick={() => navigate('/trips')}>
            Return to trips
          </Button>
        </div>
        <p className="mt-6 text-xs leading-5 text-gray-500">
          {iosConsumptionOnly
            ? 'Records from previously available features remain safely visible.'
            : 'If you previously used a financial plan, those records remain safely available after you upgrade again.'}
        </p>
      </Card>
    </div>
  );
}
